export default {
  name: 'slide-project-big-image'
}



// WEBPACK FOOTER //
// ./src/includes/SlideProjectBigImage.js